import { FeatureFlagDataModel } from '../../models/feature-flag.model';
import { combineReducers } from '@ngrx/store';
import { getHubFeatureFlagActions, getOfferFeatureFlagActions } from '../actions/feature-flag.action';
import { ApiState, createCachedApiReducer } from '../../utils/api-state';

export interface FeatureFlagState {
  hub: ApiState<FeatureFlagDataModel[]>;
  offers: ApiState<FeatureFlagDataModel[]>;
}

export const featureFlagReducer = combineReducers<FeatureFlagState>({
  hub: createCachedApiReducer(getHubFeatureFlagActions),
  offers: createCachedApiReducer(getOfferFeatureFlagActions),
});
